import { withFormsy } from 'formsy-react';
import React from 'react';

class Input extends React.Component {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event.currentTarget.value);
  }

  render() {

    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    const showRequired = this.props.showRequired();

    const {
      type = "text",
      showErrors = false,
      placeholder = "",
      icon = null,
      label = null,
      required = false,
      name,
      autofocus = false,
      inputSize = "",
      autoComplete = null,
      link = null
    } = this.props;

    const hasError = showErrors && errorMessage;

    return (
      <div className={"pt-form-group"}>
        {label && (
          <label className="pt-label" htmlFor={name}>
            {label + " "}
            {required && (
              <span className="f5 pt-text-muted">(required)</span>
            )}
          </label>
        )}
        <div className={"pt-form-content" + (hasError ? " pt-intent-danger" : "")}>
          <div className={"pt-input-group "+ (inputSize) + (hasError ? " pt-intent-danger" : "")}>
            {icon && (
              <span className={`pt-icon pt-icon-${icon}`}></span>
            )}
            <input id={name}
                   className="pt-input"
                   dir="auto"
                   autoFocus={autofocus}
                   autoComplete={autoComplete}
                   onChange={this.changeValue}
                   type={type}
                   placeholder={placeholder}
                   value={this.props.getValue() || ''}/>
            {link && (
              <a href={link} className="link" target="_blank"><span className={`pt-icon pt-icon-share`}></span></a>
            )}
          </div>
          <div className="pt-form-helper-text">
            <div className="inline-error">
              {(showErrors && errorMessage) ? (errorMessage) :
               (showErrors && showRequired) ? "Field is required." : ""}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withFormsy(Input);


// WEBPACK FOOTER //
// ./src/components/form/Input.js